<template>
  <div class="ieAlternative">
    <div class="ieAlternative__text">
      <div class="text-container">
        <div class="emoji">
          <svgicon
            class="icon-sad"
            icon="icon-sad"
            width="18"
            height="18"
          ></svgicon>
          <div class="emoji__text">Browser not supported</div>
        </div>
        <h1 class="title">We are sorry!</h1>
        <p class="paragraph">
          The site is not supported by Internet Explorer<br />
          We recommend using another browser.
        </p>
      </div>
    </div>
    <div
      class="ieAlternative__image"
      :style="{ backgroundImage: `url(${baseUrl}images/jpg/ieerror.jpg)` }"
    ></div>
  </div>
</template>
<script>
import "@/compiled-icons/icon-sad";
export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
<style lang="scss" scoped>
.ieAlternative {
  height: 100vh;
  width: 100vw;
  background-color: $black;
  color: $white;
  display: flex;
  flex-direction: row;
  &__text {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid $white-50;
    .text-container {
      display: flex;
      flex-direction: column;
    }
    .emoji {
      display: flex;
      flex-direction: row;
      align-items: center;
      .icon-sad {
        stroke: $white;
      }
      &__text {
        @include overlayM;
        text-transform: uppercase;
        color: $white;
        margin-left: 10px;
      }
    }
    .title {
      @include HH2;
      color: $white;
    }
    .paragraph {
      @include pM;
      color: $white;
    }
  }
  &__image {
    width: 50%;
    height: 100%;
    background-position: center; 
    background-repeat: no-repeat; 
    background-size: cover;
  }
}
</style>